<div
  id="app"
  [class]="[(connected && authenticated ? 'authenticated' : ''), cssClass]">
  <div id="app-header">
    <div id="app-header-inner">
      <a id="app-header-logo" [href]="pageLogo.link">
        <img src="../assets/TheMurderMatrixLogo.png" alt="The Murder Matrix Logo" style="width:165px;height:135px;">
      </a>
<!--      <span>{{pageLogo.line2}}</span>-->

      <button id="app-nav-button" type="button" (click)="navOpen = !navOpen">
        <span class="app-nav-item-icon pi pi-bars"></span>
        <span class="app-nav-item-text">Open/Close Menu</span>
      </button>

      <nav id="app-nav" [class]="{ 'app-nav-open': navOpen }">
        <!--rgba(124,7,18,1.0)-->
        <ng-template
          [ngTemplateOutlet]="menuitem"
          [ngTemplateOutletContext]="{
            items: headerMenu,
          }"></ng-template>
      </nav>
    </div>
  </div>
  <div id="app-content">
    <div id="app-messages">
      <p-messages></p-messages>
    </div>
    <router-outlet *ngIf="connected"></router-outlet>
    <div *ngIf="!connected" id="app-down">
      <p-card header="We'll Be Right Back">
        <p>We are performing maintenance and should be back online shortly.</p>
      </p-card>
    </div>
  </div>
  <div id="app-footer">
    <div id="app-footer-links">
      <ul *ngFor="let menuItem of footerMenu">
        <li>
          <a [routerLink]="menuItem.path" routerLinkActive="app-footer-item-active">
            <span *ngIf="menuItem.icon" [class]="['app-footer-item-icon', 'pi', (menuItem ? menuItem.icon : '')]"></span>
            <span class="app-footer-item-text">{{menuItem.label}}</span>
          </a>
        </li>
      </ul>
    </div>
    <p id="app-footer-copyright">&copy;
      <img src="../assets/TheMurderMatrixLogo.png" alt="The Murder Matrix Logo" style="width:16px;height:16px;">
      {{copyrightDate | date:'yyyy'}} {{copyright}} {{clientVersion}}/{{serverVersion}}
    /p>
  </div>
</div>

<p-confirmDialog key="confirmDialog" rejectButtonStyleClass="p-button-text" [baseZIndex]="9998"></p-confirmDialog>

<ng-template #menuitem let-items="items">
  <ul *ngFor="let item of items">
    <li>
      <a class="app-nav-item" [routerLink]="item.path" routerLinkActive="app-nav-item-active">
        <span *ngIf="item.icon" [class]="['app-nav-item-icon', 'pi', (item ? item.icon : '')]"></span>
        <span class="app-nav-item-text">{{item.label}}</span>
      </a>
      <ng-container *ngIf="items.items && items.items.length > 0">
        <ng-template
          [ngTemplateOutlet]="menuitem"
          [ngTemplateOutletContext]="{
            items: items.items,
          }"></ng-template>
      </ng-container>
    </li>
  </ul>
</ng-template>
